"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _config = require("@/api/common/config");
var _utils = require("@/utils");
var _changePassword = _interopRequireDefault(require("@/views/commonData/home/components/changePassword.vue"));
var _readWebOnlineTerms = _interopRequireDefault(require("@/views/commonData/home/components/readWebOnlineTerms.vue"));
var _user = require("@/api/system/user");
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'App',
  components: {
    changePassword: _changePassword.default,
    readWebOnlineTerms: _readWebOnlineTerms.default
  },
  data: function data() {
    return {
      initDialogChangePasswordVisible: false,
      initDialogReadWebOnlineTermsVisible: false,
      registerTermContent: '',
      bookingTermContent: '',
      registerTermNo: '',
      bookingTermNo: ''
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  created: function created() {
    var _this = this;
    var userInfo = sessionStorage.getItem("userInfo") && JSON.parse(sessionStorage.getItem("userInfo"));
    if (userInfo) {
      if (userInfo.registUser !== 3) {
        // 需要修改密码，并重新登录
        this.initDialogChangePasswordVisible = true;
      }
    }
    var registerTermNo = sessionStorage.getItem("updateRegisterTermNo");
    var bookingTermNo = sessionStorage.getItem("updateBookingTermNo");
    var termNos = [];
    if (registerTermNo) {
      termNos.push(registerTermNo);
      this.registerTermNo = registerTermNo;
    }
    if (bookingTermNo) {
      termNos.push(bookingTermNo);
      this.bookingTermNo = bookingTermNo;
    }
    if (termNos.length > 0) {
      (0, _user.getTermByTermNo)(termNos).then(function (res) {
        var terms = res.data;
        if (res.success && terms && terms.length > 0) {
          var _iterator = (0, _createForOfIteratorHelper2.default)(terms),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var term = _step.value;
              var termContent = _this.language === 'en' ? term.termContentEn : term.termContent;
              // const termContent = data.replace(/\r?\n/g, '<br>');
              if (term.termType === '1') {
                _this.registerTermContent = termContent;
              } else if (term.termType === '2') {
                _this.bookingTermContent = termContent;
              }
            }
            // 阅读条款
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          _this.initDialogReadWebOnlineTermsVisible = true;
        }
      });
    }
    var that = this;
    this.$hotTableUtils.setLicenseKey('8a4e2-659ac-afa83-14d2e-cb603');
    /* 注册获取列表方法 */
    this.$hotTableUtils.registMethod('getLayoutSettingsList', function (params) {
      var componentCode = params.colSettingsKey;
      var pageCode = that.$route.path;
      return new Promise(function (resolve, reject) {
        var data = {};
        data.componentCode = componentCode;
        data.pageCode = pageCode;
        (0, _config.getComponentList)(data).then(function (res) {
          var array = [];
          var list = res.result;
          if (list && list.length > 0) {
            for (var i in list) {
              var componentJson = JSON.parse(list[i].componentJson);
              if (componentJson.length > 0) {
                for (var j in componentJson) {
                  componentJson[j].content = JSON.stringify(componentJson[j].content);
                }
              }
              array = array.concat(componentJson);
            }
          }
          resolve(array);
        }).catch(function (err) {
          reject(err);
        });
      });
    });
    /* 注册删除布局方法 */
    this.$hotTableUtils.registMethod('deleteLayoutSettings', function (params) {
      return new Promise(function (resolve, reject) {
        var componentCode = params.colSettingsKey;
        var pageCode = that.$route.path;
        var layoutName = params.layoutName;
        if (!layoutName) {
          return false;
        }
        var data = {};
        data.componentCode = componentCode;
        data.pageCode = pageCode;
        data.layoutName = layoutName;
        (0, _config.deleteLayout)(data).then(function (res) {
          var list = res.result;
          if (list) {
            var componentJsons = JSON.parse(list.componentJson);
            if (componentJsons.length > 0) {
              for (var i in componentJsons) {
                componentJsons[i].content = JSON.stringify(componentJsons[i].content);
              }
            }
            resolve(componentJsons);
          } else {
            resolve('');
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    });
    /* 保存布局方法 */
    this.$hotTableUtils.registMethod('saveLayoutSettings', function (params) {
      return new Promise(function (resolve, reject) {
        var componentCode = params.colSettingsKey;
        var pageCode = that.$route.path;
        var componentJson = {
          layoutName: params.layoutName,
          gridLayoutId: (0, _utils.generateUUID)(),
          content: {
            t: Date.parse(new Date()),
            visibleColumns: params.visibleColumns,
            columnSorting: params.columnSorting,
            fixedColumnsLeft: params.fixedColumnsLeft
          }
        };
        if (params.groupColumns) {
          componentJson.content.groupColumns = params.groupColumns;
        }
        var data = {
          componentCode: componentCode,
          pageCode: pageCode,
          componentJson: JSON.stringify(componentJson)
        };
        (0, _config.saveOrUpdateCustom)(data).then(function (res) {
          if (res.result) {
            var componentJsons = JSON.parse(res.result.componentJson);
            if (componentJsons.length > 0) {
              for (var i in componentJsons) {
                componentJsons[i].content = JSON.stringify(componentJsons[i].content);
              }
            }
            resolve(componentJsons);
          } else {
            resolve('');
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    });
    /*  保存布局方法2 */
    this.$hotTableUtils.registMethod('saveAsLayoutSettings', function (params) {
      return new Promise(function (resolve, reject) {
        var componentCode = params.colSettingsKey;
        var pageCode = that.$route.path;
        var componentJson = {
          layoutName: params.layoutName,
          gridLayoutId: (0, _utils.generateUUID)(),
          content: {
            t: Date.parse(new Date()),
            visibleColumns: params.visibleColumns,
            columnSorting: params.columnSorting,
            fixedColumnsLeft: params.fixedColumnsLeft
          }
        };
        if (params.groupColumns) {
          componentJson.content.groupColumns = params.groupColumns;
        }
        var data = {
          componentCode: componentCode,
          pageCode: pageCode,
          componentJson: JSON.stringify(componentJson)
        };
        (0, _config.saveOrUpdateCustom)(data).then(function (res) {
          if (res.result) {
            var componentJsons = JSON.parse(res.result.componentJson);
            if (componentJsons.length > 0) {
              for (var i in componentJsons) {
                componentJsons[i].content = JSON.stringify(componentJsons[i].content);
              }
            }
            resolve(componentJsons);
          } else {
            resolve('');
          }
        }).catch(function (err) {
          reject(err);
        });
      });
    });
  },
  methods: {
    setInitDialogReadWebOnlineTermsVisible: function setInitDialogReadWebOnlineTermsVisible(val) {
      this.initDialogReadWebOnlineTermsVisible = val;
    }
  }
};